export default "__VITE_ASSET__D3hxeH$B__"